module.exports = __webpack_public_path__ + "static/6305-woodrose-44-feeaf659f306658e6207e2c97dfce609.jpg";